"use client";

import { useNavigationItems } from "@/context/NavigationItemsContext";
import type { NavigationItem } from "@/context/NavigationItemsContext";
import { useEffect } from "react";

interface NavigationUpdaterProps {
    items: NavigationItem[];
}

export default function NavigationUpdater({ items }: NavigationUpdaterProps) {
    const { setItems, reset } = useNavigationItems();

    useEffect(() => {
        setItems(items);

        return () => {
            reset();
        };
    }, [items, setItems, reset]);

    return null;
}
